import { Subject } from 'rxjs';

export class ContactConfig {
    constructor(public embedMode: boolean = false) {
        this.actionSubject$ = new Subject<ContactAction>();
        this.feedbackSubject$ = new Subject<ContactFeedbackAction>();
    }
    public actionSubject$: Subject<ContactAction>;
    public feedbackSubject$: Subject<ContactFeedbackAction>;
}

export class ContactAction {
    constructor(public type: ContactActionTypes, public payload: any) { }
}

export class ContactFeedbackAction {
    constructor(public type: ContactFeedbackTypes, public payload: any) { }
}

export enum ContactActionTypes {
    SWITCH_ANOTHER_CONTACT = 'SWITCH_ANOTHER_CONTACT',
    SIDE_SHEET = 'SIDE_SHEET',
}

export enum ContactFeedbackTypes {
    CONTACT_LOADED = 'CONTACT_LOADED',
    CONTACT_UPDATED = 'CONTACT_UPDATED'
}
